// import { useState } from "react";
// import css from "./adm.module.css";
// import OpicunskaRada from "./mainPages/opicunskaRada";
// import AdminProductSelector from "./catalog/adminProductSelector";
// import FiltersBooks from "./filters/filtersBooks";
// import FiltersManuscript from "./filters/filtersManuscript";
// import PriceOptPage from "./priceOtp/priceOptPage";
// import CatalogOptCom from "./priceOtp/catalogOptCom";
// import LitShowManager from "./priceOtp/litShowManager";
// import AutorAndHud from "./autorAndHud";
// import AdminForeignRights from "./adminForeignRights";
// import NovaPoshtaKeyManager from "./novaPoshta";
// import EditSunSoonText from "./EditSunSoonText";
// import DiscountAndActionAdmin from "./discountAndActionDynamic";
// import AboutAdmin from "./AboutAdmin";
// import DeliveryAdmin from "./DeliveryAdmin";
// import PublicOfferAdmin from "./PublickOfferAdmin";
// import UserCabinetEditor from "./UserCabinetEditor";
// import CommercialNewsAdmin from "./main/CommercialNewsAdmin";
// import CabinetTilesAdmin from "./users/CabinetTilesAdmin";
// import LibraryOffersAdmin from "./LibraryOffersAdmin";
// import LibraryCatalogBannerAdmin from "./LibraryCatalogBannerAdmin";
// import FooterLinksAdmin from "./FooterLinksAdmin/FooterLinksAdmin";
// const PageListFor = () => {
//   const [mainPage, setMainPage] = useState(false);
//   const [opicunskaRada, setOpicunskaRada] = useState(false);
//   const [footerLinksAdmin, setFooterLinksAdmin] = useState(false);
//   const [catalogPage, setCatalogPage] = useState(false);
//   const [mainBanner, setMainBanner] = useState(false);
//   const [filters, setFilters] = useState(false);
//   const [filtersBooks, setFiltersBooks] = useState(false);
//   const [filtersManuscript, setFiltersManuscript] = useState(false);
//   const [priceOpt, setPriceOpt] = useState(false);
//   const [actionsAndRoz, setActionsAndRoz] = useState(false);
//   const [documentoobig, setDocumentoobig] = useState(false);
//   const [litShow, setLitShow] = useState(false);
//   const [autorsHudognik, setAutorsHudognik] = useState(false);
//   const [foreiRight, setForeiRight] = useState(false);
//   const [novaKey, setNovaKey] = useState(false);
//   const [changeTextHead, setChangeTextHead] = useState(false);
//   const [banerKrohmal, setBanerKrohmal] = useState(false);
//   const [aboutPage, setAboutPage] = useState(false);
//   const [pageDelivery, setPageDelivery] = useState(false);
//   const [pubOfferPage, setPubOfferPage] = useState(false);
//   const [userCabinet, setUserCabinet] = useState(false);
//   const [banerOnCabB, setBanerOnCabB] = useState(false);
//   const [banreFors, setBanreFors] = useState(false);
//   const [banerForBib, setBanerForBib] = useState(false);
//   const [bannerFotTwoB, setBannerFotTwoB] = useState(false);
//   const mainPageClick = () => {
//     setMainPage(!mainPage);
//     setOpicunskaRada(false);
//     setFooterLinksAdmin(false);
//     setCatalogPage(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const catalogPageClick = () => {
//     setMainPage(false);
//     setCatalogPage(!catalogPage);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setFooterLinksAdmin(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const opicunscaPageClick = () => {
//     setOpicunskaRada(!opicunskaRada);
//     setFooterLinksAdmin(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const footerLinksPageClick = () => {
//     setFooterLinksAdmin(!footerLinksAdmin);
//     setOpicunskaRada(false);

//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const mainBannerCatalogPageClick = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setFooterLinksAdmin(false);
//     setCatalogPage(false);
//     setMainBanner(!mainBanner);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const filtersPageClick = () => {
//     setOpicunskaRada(false);
//     setFooterLinksAdmin(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(!filters);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const filtersBooksPageClick = () => {
//     setOpicunskaRada(false);
//     setFooterLinksAdmin(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(!filtersBooks);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const filtersManuscriptPageClick = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFooterLinksAdmin(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(!filtersManuscript);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const priceOptPageClick = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFooterLinksAdmin(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(!priceOpt);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const actionsAndRozprodagPageClick = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFooterLinksAdmin(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(!actionsAndRoz);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const documentoobigPageClick = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setFooterLinksAdmin(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(!documentoobig);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const liShowPageClick = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setFooterLinksAdmin(false);
//     setDocumentoobig(false);
//     setLitShow(!litShow);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const autorAndHudognuk = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setFooterLinksAdmin(false);
//     setLitShow(false);
//     setAutorsHudognik(!autorsHudognik);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const foreiR = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFooterLinksAdmin(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(!foreiRight);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const novaK = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setFooterLinksAdmin(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(!novaKey);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const nezabaromText = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setFooterLinksAdmin(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(!changeTextHead);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const krohmalText = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFooterLinksAdmin(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(!banerKrohmal);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const functionAboutPage = () => {
//     setOpicunskaRada(false);
//     setFooterLinksAdmin(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(!aboutPage);
//     setPageDelivery(false);
//     setUserCabinet(false);
//     setPubOfferPage(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const functionDeliveryPage = () => {
//     setOpicunskaRada(false);
//     setFooterLinksAdmin(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(!pageDelivery);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const functionPabOfferPage = () => {
//     setOpicunskaRada(false);
//     setFooterLinksAdmin(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(!pubOfferPage);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const functionUserCabinet = () => {
//     setOpicunskaRada(false);
//     setFooterLinksAdmin(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(!userCabinet);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const functionBannerOnCabB = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setFooterLinksAdmin(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(!banerOnCabB);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//   };
//   const functionBannerforTwo = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(!banreFors);
//     setBanerForBib(false);
//     setBannerFotTwoB(false);
//     setFooterLinksAdmin(false);
//   };
//   const functionBannerforLib = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(!banerForBib);
//     setBannerFotTwoB(false);
//     setFooterLinksAdmin(false);
//   };
//   const functionBannerFotTwoBb = () => {
//     setOpicunskaRada(false);
//     setMainPage(false);
//     setCatalogPage(false);
//     setMainBanner(false);
//     setFilters(false);
//     setFiltersBooks(false);
//     setFiltersManuscript(false);
//     setPriceOpt(false);
//     setActionsAndRoz(false);
//     setDocumentoobig(false);
//     setLitShow(false);
//     setAutorsHudognik(false);
//     setForeiRight(false);
//     setNovaKey(false);
//     setChangeTextHead(false);
//     setBanerKrohmal(false);
//     setAboutPage(false);
//     setPageDelivery(false);
//     setPubOfferPage(false);
//     setUserCabinet(false);
//     setBanerOnCabB(false);
//     setBanreFors(false);
//     setBanerForBib(false);
//     setBannerFotTwoB(!bannerFotTwoB);
//     setFooterLinksAdmin(false);
//   };
//   return (
//     <div className={css.wrapAdmLisPage}>
//       <div className={css.buttonWrapInPage}>
//         <div className={css.mainPageButtonO} onClick={novaK}>
//           Нова пошта ключ
//         </div>
//         <div className={css.mainPageButtonO} onClick={mainPageClick}>
//           Головна
//         </div>
//         <div className={css.mainPageButtonO} onClick={catalogPageClick}>
//           Каталог
//         </div>
//         <div className={css.mainPageButtonO} onClick={filtersPageClick}>
//           Фільтри
//         </div>
//         <div className={css.mainPageButtonO} onClick={priceOptPageClick}>
//           Прайс-гурт
//         </div>
//         <div className={css.mainPageButtonO} onClick={autorAndHudognuk}>
//           Авторам/Художникам
//         </div>
//         <div className={css.mainPageButtonO} onClick={foreiR}>
//           foreign-rights
//         </div>
//         <div className={css.mainPageButtonO} onClick={nezabaromText}>
//           Текст в шапці "Незабаром"
//         </div>
//         <div className={css.mainPageButtonO} onClick={functionAboutPage}>
//           Про видавництво
//         </div>
//         <div className={css.mainPageButtonO} onClick={functionDeliveryPage}>
//           Доставка
//         </div>
//         <div className={css.mainPageButtonO} onClick={functionPabOfferPage}>
//           Публічна оферта
//         </div>
//         <div className={css.mainPageButtonO} onClick={functionUserCabinet}>
//           Кабінет користувача
//         </div>
//         <div className={css.mainPageButtonO} onClick={functionBannerOnCabB}>
//           Банер для Бізнесу в кабінеті
//         </div>
//         <div className={css.mainPageButtonO} onClick={functionBannerforTwo}>
//           Банер для Бізнесу 2
//         </div>
//         <div className={css.mainPageButtonO} onClick={functionBannerforLib}>
//           Банер для Бібліотек
//         </div>
//         <div className={css.mainPageButtonO} onClick={functionBannerFotTwoBb}>
//           Банер для Бібліотек 1
//         </div>
//       </div>
//       {mainPage && (
//         <div className={css.buttonWrapInPage}>
//           <div className={css.mainPageButtonO} onClick={opicunscaPageClick}>
//             Опікунська рада
//           </div>
//           <div className={css.mainPageButtonO} onClick={footerLinksPageClick}>
//             Посилання футера
//           </div>
//         </div>
//       )}
//       {filters && (
//         <div className={css.buttonWrapInPage}>
//           <div className={css.mainPageButtonO} onClick={filtersBooksPageClick}>
//             Фільтри книг
//           </div>
//           <div
//             className={css.mainPageButtonO}
//             onClick={filtersManuscriptPageClick}
//           >
//             Фільтри рукописів
//           </div>
//         </div>
//       )}
//       {catalogPage && (
//         <div className={css.buttonWrapInPage}>
//           <div
//             className={css.mainPageButtonO}
//             onClick={mainBannerCatalogPageClick}
//           >
//             Головний банер
//           </div>
//           <div className={css.mainPageButtonO} onClick={krohmalText}>
//             Різнокольорові банери в низу сторінки
//           </div>
//         </div>
//       )}
//       {priceOpt && (
//         <div className={css.buttonWrapInPage}>
//           <div
//             className={css.mainPageButtonO}
//             onClick={actionsAndRozprodagPageClick}
//           >
//             Акції та розпродаж
//           </div>
//           <div className={css.mainPageButtonO} onClick={documentoobigPageClick}>
//             Документообіг, каталог
//           </div>
//           <div className={css.mainPageButtonO} onClick={liShowPageClick}>
//             Літ шоу
//           </div>
//         </div>
//       )}
//       {opicunskaRada && <OpicunskaRada />}
//       {footerLinksAdmin && <FooterLinksAdmin />}
//       {mainBanner && <AdminProductSelector />}
//       {filtersBooks && <FiltersBooks />}
//       {filtersManuscript && <FiltersManuscript />}
//       {actionsAndRoz && <PriceOptPage />}
//       {documentoobig && <CatalogOptCom />}
//       {litShow && <LitShowManager />}
//       {autorsHudognik && <AutorAndHud />}
//       {foreiRight && <AdminForeignRights />}
//       {novaKey && <NovaPoshtaKeyManager />}
//       {changeTextHead && <EditSunSoonText />}
//       {banerKrohmal && <DiscountAndActionAdmin />}
//       {aboutPage && <AboutAdmin />}
//       {pageDelivery && <DeliveryAdmin />}
//       {pubOfferPage && <PublicOfferAdmin />}
//       {userCabinet && <UserCabinetEditor />}
//       {banerOnCabB && <CommercialNewsAdmin />}
//       {banreFors && <CabinetTilesAdmin />}
//       {banerForBib && <LibraryOffersAdmin />}
//       {bannerFotTwoB && <LibraryCatalogBannerAdmin />}
//     </div>
//   );
// };
// export default PageListFor;
import { useState } from "react";
import css from "./adm.module.css";

import OpicunskaRada from "./mainPages/opicunskaRada";
import AdminProductSelector from "./catalog/adminProductSelector";
import FiltersBooks from "./filters/filtersBooks";
import FiltersManuscript from "./filters/filtersManuscript";
import PriceOptPage from "./priceOtp/priceOptPage";
import CatalogOptCom from "./priceOtp/catalogOptCom";
import LitShowManager from "./priceOtp/litShowManager";
import AutorAndHud from "./autorAndHud";
import AdminForeignRights from "./adminForeignRights";
import NovaPoshtaKeyManager from "./novaPoshta";
import EditSunSoonText from "./EditSunSoonText";
import DiscountAndActionAdmin from "./discountAndActionDynamic";
import AboutAdmin from "./AboutAdmin";
import DeliveryAdmin from "./DeliveryAdmin";
import PublicOfferAdmin from "./PublickOfferAdmin";
import UserCabinetEditor from "./UserCabinetEditor";
import CommercialNewsAdmin from "./main/CommercialNewsAdmin";
import CabinetTilesAdmin from "./users/CabinetTilesAdmin";
import LibraryOffersAdmin from "./LibraryOffersAdmin";
import LibraryCatalogBannerAdmin from "./LibraryCatalogBannerAdmin";
import FooterLinksAdmin from "./FooterLinksAdmin/FooterLinksAdmin";
import BlogBannerAdmin from "./BlogBannerAdmin";

const PageListFor = () => {
  const [openGroup, setOpenGroup] = useState(null);
  const [activeSection, setActiveSection] = useState(null);

  const toggleGroup = (groupName) => {
    setActiveSection(null);

    setOpenGroup((previousGroup) =>
      previousGroup === groupName ? null : groupName,
    );
  };

  const toggleSection = (sectionName) => {
    setOpenGroup(null);

    setActiveSection((previousSection) =>
      previousSection === sectionName ? null : sectionName,
    );
  };

  const renderAdminSection = () => {
    switch (activeSection) {
      case "opicunskaRada":
        return <OpicunskaRada />;

      case "footerLinks":
        return <FooterLinksAdmin />;

      case "catalogMainBanner":
        return <AdminProductSelector />;

      case "filtersBooks":
        return <FiltersBooks />;

      case "filtersManuscript":
        return <FiltersManuscript />;

      case "actionsAndSale":
        return <PriceOptPage />;

      case "documentFlow":
        return <CatalogOptCom />;

      case "litShow":
        return <LitShowManager />;

      case "authorsAndArtists":
        return <AutorAndHud />;

      case "foreignRights":
        return <AdminForeignRights />;

      case "novaPoshta":
        return <NovaPoshtaKeyManager />;

      case "headerSoonText":
        return <EditSunSoonText />;

      case "coloredBanners":
        return <DiscountAndActionAdmin />;

      case "about":
        return <AboutAdmin />;

      case "delivery":
        return <DeliveryAdmin />;

      case "publicOffer":
        return <PublicOfferAdmin />;

      case "userCabinet":
        return <UserCabinetEditor />;

      case "businessCabinetBanner":
        return <CommercialNewsAdmin />;

      case "businessSecondBanner":
        return <CabinetTilesAdmin />;

      case "libraryOffers":
        return <LibraryOffersAdmin />;

      case "libraryCatalogBanner":
        return <LibraryCatalogBannerAdmin />;

      case "blogBanner":
        return <BlogBannerAdmin />;

      default:
        return null;
    }
  };

  return (
    <div className={css.wrapAdmLisPage}>
      <div className={css.buttonWrapInPage}>
        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("novaPoshta")}
        >
          Нова пошта ключ
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleGroup("main")}
        >
          Головна
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("blogBanner")}
        >
          Банер блогу
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleGroup("catalog")}
        >
          Каталог
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleGroup("filters")}
        >
          Фільтри
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleGroup("priceOpt")}
        >
          Прайс-гурт
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("authorsAndArtists")}
        >
          Авторам/Художникам
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("foreignRights")}
        >
          foreign-rights
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("headerSoonText")}
        >
          Текст в шапці "Незабаром"
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("about")}
        >
          Про видавництво
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("delivery")}
        >
          Доставка
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("publicOffer")}
        >
          Публічна оферта
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("userCabinet")}
        >
          Кабінет користувача
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("businessCabinetBanner")}
        >
          Банер для Бізнесу в кабінеті
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("businessSecondBanner")}
        >
          Банер для Бізнесу 2
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("libraryOffers")}
        >
          Банер для Бібліотек
        </div>

        <div
          className={css.mainPageButtonO}
          onClick={() => toggleSection("libraryCatalogBanner")}
        >
          Банер для Бібліотек 1
        </div>
      </div>

      {openGroup === "main" && (
        <div className={css.buttonWrapInPage}>
          <div
            className={css.mainPageButtonO}
            onClick={() => toggleSection("opicunskaRada")}
          >
            Опікунська рада
          </div>

          <div
            className={css.mainPageButtonO}
            onClick={() => toggleSection("footerLinks")}
          >
            Посилання футера
          </div>
        </div>
      )}

      {openGroup === "catalog" && (
        <div className={css.buttonWrapInPage}>
          <div
            className={css.mainPageButtonO}
            onClick={() => toggleSection("catalogMainBanner")}
          >
            Головний банер
          </div>

          <div
            className={css.mainPageButtonO}
            onClick={() => toggleSection("coloredBanners")}
          >
            Різнокольорові банери внизу сторінки
          </div>
        </div>
      )}

      {openGroup === "filters" && (
        <div className={css.buttonWrapInPage}>
          <div
            className={css.mainPageButtonO}
            onClick={() => toggleSection("filtersBooks")}
          >
            Фільтри книг
          </div>

          <div
            className={css.mainPageButtonO}
            onClick={() => toggleSection("filtersManuscript")}
          >
            Фільтри рукописів
          </div>
        </div>
      )}

      {openGroup === "priceOpt" && (
        <div className={css.buttonWrapInPage}>
          <div
            className={css.mainPageButtonO}
            onClick={() => toggleSection("actionsAndSale")}
          >
            Акції та розпродаж
          </div>

          <div
            className={css.mainPageButtonO}
            onClick={() => toggleSection("documentFlow")}
          >
            Документообіг, каталог
          </div>

          <div
            className={css.mainPageButtonO}
            onClick={() => toggleSection("litShow")}
          >
            Літ шоу
          </div>
        </div>
      )}

      <div className={css.adminContent}>{renderAdminSection()}</div>
    </div>
  );
};

export default PageListFor;
